import { render, staticRenderFns } from "./EmployeeTagModal.vue?vue&type=template&id=1a34fefc"
import script from "./EmployeeTagModal.vue?vue&type=script&lang=ts"
export * from "./EmployeeTagModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a34fefc')) {
      api.createRecord('1a34fefc', component.options)
    } else {
      api.reload('1a34fefc', component.options)
    }
    module.hot.accept("./EmployeeTagModal.vue?vue&type=template&id=1a34fefc", function () {
      api.rerender('1a34fefc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/employee/EmployeeTagModal.vue"
export default component.exports